import React, { useRef } from "react";
import { Input } from "antd";
import validatePesel from "./validatePesel"; // Import your PESEL validation function

const PeselInput = ({ disabled, value = "", onChange, placeholder }) => {
    const PESEL_LENGTH = 11; // PESEL is always 11 digits
    const inputRef = useRef(null); // Ref to keep track of the input

    // Check if the PESEL is valid
    const isValidPesel = (pesel) => {
        if (!pesel) return false; // Empty input is invalid
        const { isValid } = validatePesel(pesel); // Use the imported validatePesel function
        return isValid;
    };

    return (
        <Input
            ref={inputRef} // Use ref to ensure the input stays focused
            disabled={disabled}
            addonAfter={
                value !== "" ? (
                    isValidPesel(value) ? (
                        <span style={{ color: "green" }}>✔</span>
                    ) : (
                        <span style={{ color: "red" }}>✖</span>
                    )
                ) : null
            }
            value={value}
            onChange={(e) => {
                const rawValue = e.target.value.replace(/\s+/g, ""); // Remove spaces
                if (!/^\d*$/.test(rawValue)) return; // Allow only numeric input
                if (rawValue.length > PESEL_LENGTH) return; // Limit to 11 digits
                onChange(rawValue); // Pass the raw value back to the parent
            }}
            placeholder={placeholder}
            maxLength={PESEL_LENGTH}
        />
    );
};

export default PeselInput;
